import { Create } from 'react-admin'

import AuthorForm from './AuthorForm'

const AuthorCreate = props => (
  <Create redirect="list" {...props}>
    <AuthorForm />
  </Create>
)

export default AuthorCreate
